"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

require("intersection-observer");

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Profile = _interopRequireDefault(require("./Profile"));

var _Tasks = _interopRequireDefault(require("./Tasks"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _Advertisement = _interopRequireDefault(require("./Advertisement"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Description = function Description(props) {
  var tasks = props.tasks,
      profile = props.profile,
      advertisement = props.advertisement,
      other = (0, _objectWithoutProperties2["default"])(props, ["tasks", "profile", "advertisement"]);
  var t = (0, _useTranslation["default"])();

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    flexDirection: "column",
    padding: 4
  }, other), (0, _core.jsx)(_Text["default"], {
    as: "h2",
    variant: "headline3",
    gutter: 2
  }, t('description')), (0, _core.jsx)(_Advertisement["default"], {
    css: /*#__PURE__*/(0, _css2["default"])({
      marginBottom: spacing(4)
    }, ";label:Description;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9EZXNjcmlwdGlvbi9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNkJxQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvUmVzcG9uc2l2ZUpvYkNhcmQvRGVzY3JpcHRpb24vaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgJ2ludGVyc2VjdGlvbi1vYnNlcnZlcic7XG5cbmltcG9ydCBGbGV4LCB7IEZsZXhQcm9wcyB9IGZyb20gJy4uLy4uL0ZsZXgnO1xuaW1wb3J0IFRleHQgZnJvbSAnLi4vLi4vVGV4dCc7XG5pbXBvcnQgUHJvZmlsZSBmcm9tICcuL1Byb2ZpbGUnO1xuaW1wb3J0IFRhc2tzIGZyb20gJy4vVGFza3MnO1xuXG5pbXBvcnQgdXNlVGhlbWUgZnJvbSAnLi4vLi4vc3R5bGVzL3VzZVRoZW1lJztcbmltcG9ydCB1c2VUcmFuc2xhdGlvbiBmcm9tICcuLi9UcmFuc2xhdGlvblByb3ZpZGVyL3VzZVRyYW5zbGF0aW9uJztcbmltcG9ydCBBZHZlcnRpc2VtZW50IGZyb20gJy4vQWR2ZXJ0aXNlbWVudCc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgRGVzY3JpcHRpb25Qcm9wcyBleHRlbmRzIEZsZXhQcm9wczwnZGl2Jz4ge1xuICB0YXNrcz86IHN0cmluZztcbiAgcHJvZmlsZT86IHN0cmluZztcbiAgYWR2ZXJ0aXNlbWVudD86IHN0cmluZztcbn1cblxuY29uc3QgRGVzY3JpcHRpb246IEZ1bmN0aW9uQ29tcG9uZW50PERlc2NyaXB0aW9uUHJvcHM+ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgdGFza3MsIHByb2ZpbGUsIGFkdmVydGlzZW1lbnQsIC4uLm90aGVyIH0gPSBwcm9wcztcbiAgY29uc3QgdCA9IHVzZVRyYW5zbGF0aW9uKCk7XG4gIGNvbnN0IHsgc3BhY2luZyB9ID0gdXNlVGhlbWUoKTtcblxuICByZXR1cm4gKFxuICAgIDxGbGV4IGZsZXhEaXJlY3Rpb249XCJjb2x1bW5cIiBwYWRkaW5nPXs0fSB7Li4ub3RoZXJ9PlxuICAgICAgPFRleHQgYXM9XCJoMlwiIHZhcmlhbnQ9XCJoZWFkbGluZTNcIiBndXR0ZXI9ezJ9PlxuICAgICAgICB7dCgnZGVzY3JpcHRpb24nKX1cbiAgICAgIDwvVGV4dD5cbiAgICAgIDxBZHZlcnRpc2VtZW50IGNzcz17eyBtYXJnaW5Cb3R0b206IHNwYWNpbmcoNCkgfX0gYWR2ZXJ0aXNlbWVudD17YWR2ZXJ0aXNlbWVudH0gLz5cbiAgICAgIDxUYXNrcyBjc3M9e3sgbWFyZ2luQm90dG9tOiBzcGFjaW5nKDQpIH19IHRhc2tzPXt0YXNrc30gLz5cbiAgICAgIDxQcm9maWxlIHByb2ZpbGU9e3Byb2ZpbGV9IC8+XG4gICAgPC9GbGV4PlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgRGVzY3JpcHRpb247XG4iXX0= */")),
    advertisement: advertisement
  }), (0, _core.jsx)(_Tasks["default"], {
    css: /*#__PURE__*/(0, _css2["default"])({
      marginBottom: spacing(4)
    }, ";label:Description;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9EZXNjcmlwdGlvbi9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJhIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9EZXNjcmlwdGlvbi9pbmRleC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCAnaW50ZXJzZWN0aW9uLW9ic2VydmVyJztcblxuaW1wb3J0IEZsZXgsIHsgRmxleFByb3BzIH0gZnJvbSAnLi4vLi4vRmxleCc7XG5pbXBvcnQgVGV4dCBmcm9tICcuLi8uLi9UZXh0JztcbmltcG9ydCBQcm9maWxlIGZyb20gJy4vUHJvZmlsZSc7XG5pbXBvcnQgVGFza3MgZnJvbSAnLi9UYXNrcyc7XG5cbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi8uLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IHVzZVRyYW5zbGF0aW9uIGZyb20gJy4uL1RyYW5zbGF0aW9uUHJvdmlkZXIvdXNlVHJhbnNsYXRpb24nO1xuaW1wb3J0IEFkdmVydGlzZW1lbnQgZnJvbSAnLi9BZHZlcnRpc2VtZW50JztcblxuZXhwb3J0IGludGVyZmFjZSBEZXNjcmlwdGlvblByb3BzIGV4dGVuZHMgRmxleFByb3BzPCdkaXYnPiB7XG4gIHRhc2tzPzogc3RyaW5nO1xuICBwcm9maWxlPzogc3RyaW5nO1xuICBhZHZlcnRpc2VtZW50Pzogc3RyaW5nO1xufVxuXG5jb25zdCBEZXNjcmlwdGlvbjogRnVuY3Rpb25Db21wb25lbnQ8RGVzY3JpcHRpb25Qcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyB0YXNrcywgcHJvZmlsZSwgYWR2ZXJ0aXNlbWVudCwgLi4ub3RoZXIgfSA9IHByb3BzO1xuICBjb25zdCB0ID0gdXNlVHJhbnNsYXRpb24oKTtcbiAgY29uc3QgeyBzcGFjaW5nIH0gPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXggZmxleERpcmVjdGlvbj1cImNvbHVtblwiIHBhZGRpbmc9ezR9IHsuLi5vdGhlcn0+XG4gICAgICA8VGV4dCBhcz1cImgyXCIgdmFyaWFudD1cImhlYWRsaW5lM1wiIGd1dHRlcj17Mn0+XG4gICAgICAgIHt0KCdkZXNjcmlwdGlvbicpfVxuICAgICAgPC9UZXh0PlxuICAgICAgPEFkdmVydGlzZW1lbnQgY3NzPXt7IG1hcmdpbkJvdHRvbTogc3BhY2luZyg0KSB9fSBhZHZlcnRpc2VtZW50PXthZHZlcnRpc2VtZW50fSAvPlxuICAgICAgPFRhc2tzIGNzcz17eyBtYXJnaW5Cb3R0b206IHNwYWNpbmcoNCkgfX0gdGFza3M9e3Rhc2tzfSAvPlxuICAgICAgPFByb2ZpbGUgcHJvZmlsZT17cHJvZmlsZX0gLz5cbiAgICA8L0ZsZXg+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBEZXNjcmlwdGlvbjtcbiJdfQ== */")),
    tasks: tasks
  }), (0, _core.jsx)(_Profile["default"], {
    profile: profile
  }));
};

__signature__(Description, "useTranslation{t}\nuseTheme{{ spacing }}", function () {
  return [_useTranslation["default"], _useTheme2["default"]];
});

var _default = Description;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Description, "Description", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Description/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();